import { RootState } from '@/store';
import { STOCK_BALANCES_SLICE_NAME } from './models';

export const stockBalancesSelector = (state: RootState) => state[STOCK_BALANCES_SLICE_NAME];
export const selectQuery = (state: RootState) => state[STOCK_BALANCES_SLICE_NAME].query;
